import { createFileRoute, redirect } from '@tanstack/react-router'
import { pickLocale } from '@/i18n/config'

export const Route = createFileRoute('/')({
  // Server: HTTP 302 so crawlers and initial page loads redirect before any HTML.
  server: {
    handlers: {
      GET: async ({ request }) => {
        const locale = pickLocale(request.headers.get('accept-language') ?? '')
        return new Response(null, { status: 302, headers: { Location: `/${locale}` } })
      },
    },
  },
  // Client: redirect() in the loader covers SPA navigations back to '/'.
  loader: () => {
    throw redirect({ to: '/$locale', params: { locale: 'fr' } })
  },
})
